import React from 'react'
import MaterialSymbol from '../material-symbol'

const AddAPhoto = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="add_a_photo" {...props} />
))

AddAPhoto.displayName = 'AddAPhoto'

export default AddAPhoto
